export const formatNumber = (
  value: number,
  locale: string = "en-US",
  options: Intl.NumberFormatOptions = {},
): string => {
  return new Intl.NumberFormat(locale, options).format(value);
};

export const formatBigNumber = (
  value: bigint | number,
  maximumFractionDigits: number = 0,
): string => {
  return formatNumber(Number(value), "en-US", {
    notation: "compact",
    compactDisplay: "short",
    minimumFractionDigits: 0,
    maximumFractionDigits,
  });
};

export const formatPercentage = (
  value: number,
  locale: string = "en-US",
  options: Intl.NumberFormatOptions = {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  },
): string => {
  return new Intl.NumberFormat(locale, options).format(value);
};
